import { render, staticRenderFns } from "./MapaEvento.vue?vue&type=template&id=afc047bc&scoped=true"
import script from "./MapaEvento.vue?vue&type=script&lang=js"
export * from "./MapaEvento.vue?vue&type=script&lang=js"
import style0 from "./MapaEvento.vue?vue&type=style&index=0&id=afc047bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc047bc",
  null
  
)

export default component.exports